import { Injectable } from '@angular/core';
import { Observable, ReplaySubject } from 'rxjs';
import { map, first } from 'rxjs/operators';
import { ACResourceService } from '@appcatalyst/ng-cms-core-lib';

@Injectable({
  providedIn: 'root'
})
export class FacilitiesService {
  private facilities = new ReplaySubject<any>(1);
  private facilitiesPicker = new ReplaySubject<any>(1);

  constructor(private cms: ACResourceService) { }

  public updateFacilities = (params: any) => {
    var path = `/facilities`
    return this.cms.request('GET', path, params).pipe(
      first(),
      map(data => {
        this.facilities.next(data)
        return data
      })
    )
  }

  public getFacilities = (): Observable<any> => {
    return this.facilities.asObservable()
  }

  public updateFacilitiesPicker = () => {
    var path = `facilities`
    return this.cms.request('GET', path).pipe(
      first(),
      map(data => {
        this.facilitiesPicker.next(data)
        return data
      })
    )
  }

  public getFacilitiesPicker = (): Observable<any> => {
    return this.facilitiesPicker.asObservable()
  }
}
